import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationIntegrationAssetsPublishVariationsArgs,
  BackendVariation,
} from 'src/types/backend';

import { VARIATION_EXPORT_INFO_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation IntegrationAssetsPublishVariations(
    $variationIds: [ID!]!
    $assetName: String!
    $accountId: ID!
    $dataSource: PerformanceCenterDataSource!
  ) {
    integrationAssetsPublishVariations(
      variationIds: $variationIds
      assetName: $assetName
      accountId: $accountId
      dataSource: $dataSource
    ) {
      id
      exportInfo {
        ...VariationExportInfo
      }
    }
  }
  ${VARIATION_EXPORT_INFO_FRAGMENT}
`;

type Variables = Pick<
  BackendMutationIntegrationAssetsPublishVariationsArgs,
  'variationIds' | 'assetName' | 'accountId' | 'dataSource'
>;
type Result = Pick<BackendVariation, 'id' | 'exportInfo'>[];

export const publishVariations = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
